// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/app_settings_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Value } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_struct } from '@bufbuild/protobuf/wkt';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/app_settings_response.proto.
 */
export const file_responses_v1_app_settings_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CihyZXNwb25zZXMvdjEvYXBwX3NldHRpbmdzX3Jlc3BvbnNlLnByb3RvEgxyZXNwb25zZXMudjEioQEKE0FwcFNldHRpbmdzUmVzcG9uc2USQQoIc2V0dGluZ3MYASADKAsyLy5yZXNwb25zZXMudjEuQXBwU2V0dGluZ3NSZXNwb25zZS5TZXR0aW5nc0VudHJ5GkcKDVNldHRpbmdzRW50cnkSCwoDa2V5GAEgASgJEiUKBXZhbHVlGAIgASgLMhYuZ29vZ2xlLnByb3RvYnVmLlZhbHVlOgI4AUKDAQoQY29tLnJlc3BvbnNlcy52MUIYQXBwU2V0dGluZ3NSZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM',
        [file_google_protobuf_struct]
    );

/**
 * @generated from message responses.v1.AppSettingsResponse
 */
export type AppSettingsResponse = Message<'responses.v1.AppSettingsResponse'> & {
    /**
     * @generated from field: map<string, google.protobuf.Value> settings = 1;
     */
    settings: { [key: string]: Value };
};

/**
 * Describes the message responses.v1.AppSettingsResponse.
 * Use `create(AppSettingsResponseSchema)` to create a new message.
 */
export const AppSettingsResponseSchema: GenMessage<AppSettingsResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_app_settings_response, 0);
